import type { SearchProvider, SearchResult } from './search-provider';
import { coordinateProvider } from './coordinate-provider';
import { trackProvider } from './track-provider';
import { geocodeProvider } from './geocode-provider';

/** Top-bar search: coordinates and geocoded addresses/places. */
const PLACE_PROVIDERS: SearchProvider[] = [coordinateProvider, geocodeProvider];

/** Feed-layer search: live tracks and contacts by callsign. */
const UNIT_PROVIDERS: SearchProvider[] = [trackProvider];

/** Search places/addresses + coordinates (top header bar). */
export function searchPlaces(query: string): Promise<SearchResult[]> {
  return runProviders(PLACE_PROVIDERS, query);
}

/** Search live tracks/contacts by callsign (Feed Layers). */
export function searchUnits(query: string): Promise<SearchResult[]> {
  return runProviders(UNIT_PROVIDERS, query);
}

/** Run a set of providers and merge their results (providers never throw). */
async function runProviders(providers: SearchProvider[], query: string): Promise<SearchResult[]> {
  const trimmed = query.trim();
  if (trimmed.length === 0) return [];
  const grouped = await Promise.all(providers.map((provider) => provider.search(trimmed)));
  return grouped.flat();
}
